<template>
    <transition name="fade">
        <div class="loading" v-if="show">
            <div class="loading-container">
                <div class="circle-container">
                    <div class="circle"></div>
                    <img src="/images/jhma-circle.png" alt="ロゴ">
                </div>
                <p>
                    <span>少</span>
                    <span>々</span>
                    <span>お</span>
                    <span>待</span>
                    <span>ち</span>
                    <span>く</span>
                    <span>だ</span>
                    <span>さ</span>
                    <span>い</span>
                    <span>...</span>
                </p>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: "Loading",

    data() {
        return {
            show: false,
            handler: null,
        }
    },

    props: {
        isShow: {
            type: Boolean,
            required: true
        }
    },

    watch: {
        isShow: function (isShow) {
            if (this.handler !== null) {
                clearTimeout(this.handler);
                this.handler = null;
            }
            if (isShow) {
                this.handler = setTimeout(() => this.show = true, 500);
            } else {
                this.show = false;
            }
        }
    }
}
</script>

<style scoped>

</style>
